import type { DashboardOverviewResponseDTO } from '@/api/generated/model';
import { formatCompact, formatMoney } from '@/lib/money';
import type { MetricCardItem } from '@/features/users/components/MetricCardsRow';

const countFormatter = new Intl.NumberFormat('en-AU');

function fmtCount(n?: number | null): string {
  return n != null ? countFormatter.format(n) : '—';
}

/** User list header — CMP showed Total Users, Active, New, Revenue; map to real overview fields. */
export function userListMetricsFromOverview(
  data: DashboardOverviewResponseDTO | undefined,
): MetricCardItem[] {
  if (!data) {
    return [
      { label: 'Total Users', value: '—' },
      { label: 'Active (30d)', value: '—' },
      { label: 'New (30d)', value: '—' },
      { label: 'Total Revenue', value: '—' },
    ];
  }
  return [
    { label: 'Total Users', value: fmtCount(data.totalUsers) },
    { label: 'Active (30d)', value: fmtCount(data.activeUsers30d) },
    { label: 'New (30d)', value: fmtCount(data.newUsers30d) },
    {
      label: 'Total Revenue',
      value: data.totalRevenue != null ? formatMoney(data.totalRevenue) : '—',
    },
  ];
}

/** Content list KPI strip — CMP: Total Content, Exclusive Posts, Total Purchases (+ views/earnings). */
export function contentListMetricsFromOverview(
  data: DashboardOverviewResponseDTO | undefined,
): MetricCardItem[] {
  if (!data) {
    return [
      { label: 'Total Content', value: '—' },
      { label: 'Exclusive Posts', value: '—' },
      { label: 'Total Views', value: '—' },
      { label: 'Total Purchases', value: '—' },
    ];
  }
  return [
    { label: 'Total Content', value: fmtCount(data.totalContent) },
    { label: 'Exclusive Posts', value: fmtCount(data.exclusivePosts) },
    {
      label: 'Total Views',
      value: data.totalViews != null ? formatCompact(data.totalViews) : '—',
    },
    { label: 'Total Purchases', value: fmtCount(data.totalPurchases) },
  ];
}
